export const GET_SYNC_STATUS_SUCCESS = "GET_SYNC_STATUS_SUCCESS";
export const GET_SYNC_STATUS_FAILURE = "GET_SYNC_STATUS_FAILURE";
export const SET_PLASMA_SYNC_INFO = "SET_PLASMA_SYNC_INFO";